// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export const LOGO_DARK_BG = 'https://wso2.cachefly.net/wso2/sites/all/image_resources/logos/WSO2-Logo-White.png';
export const LOGO_LIGHT_BG = 'https://wso2.cachefly.net/wso2/sites/all/image_resources/logos/WSO2-Logo-Black.png';

const logoStyle = {
    maxWidth: 90,
    paddingRight: 10,
    marginTop: 4,
};

const Logo = ({ darkBackground = true, ...props }) => (
  <img
    alt="Logo"
    style={logoStyle}
    src={darkBackground ? LOGO_DARK_BG : LOGO_LIGHT_BG}
    {...props}
  />
);

export default Logo;
